import React, { Component } from 'react'
import { API_HOST } from 'config'
import { 
  defaultWorkingHours, 
  defaultWorkingDays, 
  defaultLessons, 
  priceGroup, 
  customLesson, 
  defaultPackages, 
  customPackage,
  groupLessonOptions,
  defaultDescription,
  formStates,
} from 'const'
import ProfileForm from "components/ProfileForm"

import trophy from './assets/trophy.png'

const savePro = (data) => {
  return fetch(`${API_HOST}/register/pros`,{
    method: 'PATCH',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).then(res => {
    if (!res.ok) {
        throw new Error(res)
    }
    return res
  })
  .then(res => res.json())
}

const getPro = (id) => {
  if(!id){
      throw new Error("please provide id")
  }

  return fetch(`${API_HOST}/register/pros/${id}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  })
  .then(res => {
    if (!res.ok) {
      throw new Error(res);
    }
    return res;
  })
  .then(res => res.json());
}

const addPriceIDs = item => ({
  ...item,
  prices: item.prices.map((price, index) => (!price.hasOwnProperty('id') ? {...price, id: index+1} : {...price}))
}) 

const getID = list => list.pop().id+1

class Profile extends Component {

  state = {
    error: false,
    saved: false,
    saving: false,
    saveError: false,
    loading: true,
    pro: {},
    interval: 1000 * 60 * 5, // 5 min
    saveIntervalID: null,
    ui: {
      state: formStates.PROFILE,
      autosave: false,
    },
  }

  addCurrency = currency => list => list.map(item => ({...item, currency: currency}))

  listFilter = (defaults = [] , proValues = []) => defaults.filter(l => !proValues.map(l => l.type).includes(l.type))

  async componentDidMount(){
    const { match: { params: { id = null } } } = this.props
    const { interval } = this.state
    try{
        
      await this.setStateAsync({ 
        error: false,
        saved: false,
        loading: true
      })
      
      const res = await getPro(id);

      let pro = res.shift()
      pro = this.initPro(pro)

      const { ui = {} } = pro

      await this.setStateAsync({
        pro: pro,
        loading: false,
        saved: false,
        error: false,
        ui: ui,
      })

    }
    catch(err){
      console.log(err);
      
      await this.setStateAsync({ 
        error: true,
        saved: false,
        loading: false
      })
    }

    // start autosave
    const intID = setInterval(this.autoSave, parseInt(interval, 10));
      
    await this.setStateAsync({
      saveIntervalID: intID,
    })
  }

  componentWillUnmount(){
    this.stopAutoSave()
  }

  autoSave = () => {
    const { saving, loading, pro, ui } = this.state
    
    if(saving || loading || !pro || ui.state === formStates.GROUPS){
      return
    }
    else{
      this.savePro(true)
    }
  }

  stopAutoSave = () => {
    const { saveIntervalID } = this.state
    if(saveIntervalID){
      clearInterval(saveIntervalID)
    }
  }

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve)
    })
  }

  setFormState = async (state) => {
    await this.setStateAsync({
      ui: {...this.state.ui, state: state},
    })
  }

  enabledOnly = (item) => item.enabled
    
  savePro = async (autosave = false, ready = false) => {
    const { onSave } = this.props
    const { ui } = this.state

    if(ready){
      this.stopAutoSave()
    }

    try{
      await this.setStateAsync({ 
        saveError: false,
        saved: false,
        saving: true
      })

      const payload = {
        ...this.state.pro,
        ready: ready,
        ui: {...ui, autosave: autosave},
        packages: this.state.pro.packages.filter(this.enabledOnly),
        lessons: this.state.pro.lessons.filter(this.enabledOnly)
      }
  
      const res = await savePro(payload)
      let pro = res.shift()
      
      pro = this.initPro(pro)

      const message = autosave ? 'Form just autosaved!' : 'Form saved'

      // if this is autosave, do not override state because user will loose edits
      await this.setStateAsync({
        pro: autosave ? {...this.state.pro} : pro,
        saving: false, 
        saved: true,
        saveError: false,
      })
    
      onSave(message, 'DEFAULT')

    }
    catch(err){
      this.setState({
        saveError: true,
        saved: false,
        saving: false
      });

      onSave('Error saving form, please contact support or try again later', 'ERROR')
    }
  }

  

  initPro = (pro) => {

    pro.workingHours = pro.workingHours ? pro.workingHours : defaultWorkingHours
    pro.workingDays = pro.workingDays ? pro.workingDays : defaultWorkingDays
    
    const { currency = 'EUR'} = pro

    const addProCurrency = this.addCurrency(currency)
    
    const defaultPackagesWithCurrencyAndPro = defaultPackages(currency)(pro.firstName, pro.lastName)
    
    pro.lessons = pro.lessons ? [...pro.lessons, ...this.listFilter(addProCurrency(defaultLessons), pro.lessons) ] : addProCurrency(defaultLessons)

    // add id's to prices
    pro.lessons = pro.lessons.map(addPriceIDs)

    pro.packages = pro.packages ? [...pro.packages, ...this.listFilter(defaultPackagesWithCurrencyAndPro, pro.packages) ] : defaultPackagesWithCurrencyAndPro
    pro.groupLesson = pro.groupLesson ? pro.groupLesson : groupLessonOptions[0]
    pro.bio = pro.bio || defaultDescription
    pro.defaultImage = pro.defaultImage || false

    return pro
  }

  getValue = (event) => {
      const res = ('type' in event.target && event.target.type === 'checkbox') ? event.target.checked  : event.target.value
      return res
  }

  setProValue = async (event) => {
    if(event instanceof Array){
      for (const e of event) {
        await this.setStateAsync({ 
          pro: {...this.state.pro, [e.target.name]: this.getValue(e)}
        })
      }
    }
    else{
      await this.setStateAsync({ 
        pro: {...this.state.pro, [event.target.name]: this.getValue(event)}
      })
    }
  }

  setProLessons = async (payload) => {
    const { type } = payload
    const { lessons } = this.state.pro
    
    const updatedLessons = lessons.map((lesson, i) => {
      return (type === lesson.type) ? { ...payload } : lesson
    })
    
    await this.setStateAsync({ 
      pro: {...this.state.pro, 'lessons': updatedLessons}
    })
  }

  toggleLesson = async (payload) => {
    const { type } = payload
    const { lessons } = this.state.pro
    
    const updatedLessons = lessons.map((lesson, i) => {
      return (type === lesson.type) ? { ...lesson, enabled: !lesson.enabled } : lesson
    })

    await this.setStateAsync({ 
      pro: {...this.state.pro, 'lessons': updatedLessons}
    })
  }

  addPriceGroup = async (type) => {
    if(!type){
      throw new Error('type is required to add price group')
    }

    const { lessons } = this.state.pro
    
    const updatedLessons = lessons.map((lesson, i) => {
      return (type === lesson.type) ? { ...lesson, prices: [...lesson.prices, {...priceGroup, id: getID(lesson.prices)}] } : lesson
    })

    await this.setStateAsync({ 
      pro: {...this.state.pro, 'lessons': updatedLessons}
    })
  }

  removePrice(prices, id){
    return prices.filter(price => price.id !== id)
  }

  removePriceGroup = async (type, id) => {
    if(!type){
      throw new Error('type is required to remove price group')
    }
    if(!id){
      throw new Error('id is required to remove price group')
    }

    const { lessons } = this.state.pro
      
    const updatedLessons = lessons.map((lesson, i) => {
        return (type === lesson.type) 
          ? 
            { ...lesson, prices: [...this.removePrice(lesson.prices, id)] } 
          : 
          lesson
    })

    await this.setStateAsync({ 
        pro: {...this.state.pro, 'lessons': updatedLessons}
    })
  }

    addCustomLesson = async () => {
        const { lessons } = this.state.pro
        const count = lessons.filter(lesson => lesson.custom).length
        
        await this.setStateAsync({ 
            pro: {
              ...this.state.pro, 
              'lessons': [
                ...lessons, {
                  ...customLesson, 
                  type: `Custom lesson ${count + 1}`,
                  weight: lessons.length + 1,
                }
              ]
            }
        })
        
    }
    
  addCustomPackage = async () => {
    const { packages, currency = 'EUR' } = this.state.pro
    
    const count = packages.filter(item => item.custom).length
    
    await this.setStateAsync({ 
        pro: {
          ...this.state.pro, 
          'packages': [
            ...packages, {
              ...customPackage, 
              type: `Custom package ${count + 1}`,
              weight: packages.length + 1,
              currency: currency
            }
          ]
        }
    })
      
  }

  togglePackage = async (payload) => {
    const { type } = payload
    const { packages } = this.state.pro
    
    const updatedPackages = packages.map((item, i) => {
        return (type === item.type) ? { ...item, enabled: !item.enabled } : item
    })

    await this.setStateAsync({ 
      pro: {...this.state.pro, 'packages': updatedPackages}
    })
  }

  setProPackages = async (payload) => {
    const { type } = payload
    const { packages } = this.state.pro
    
    const updatedPackages = packages.map((item, i) => {
        return (type === item.type) ? { ...payload } : item
    })
    
    await this.setStateAsync({ 
      pro: {...this.state.pro, 'packages': updatedPackages}
    })
  }

  
  changeFormState = async (event, state) => {
    await this.setStateAsync({ 
      ui: {...this.state.ui, 'state': state}
    })
  }

  render(){

    if(this.state.error){
      return(
        <section className="content">
          <p>Not found</p>
        </section>
      )
    }

    return (
      <article className="page article">
        <header className="header">
          <img className="header--icon img--trophy" src={trophy} alt="Birdietime registration" />
          <div className="header--content">
            <h1>Welcome to the Birdietime registration!</h1>
            <p>Next you will be guided to create a Golf Pro profile page on Birdietime and sell your golf lesson services both on Birdietime.com and your own or club website.</p>
          </div>  
        </header>
        <section className="content">
          <ProfileForm 
            {...this.state.pro}
            formState={this.state.ui.state}
            onSubmit={() => this.savePro(false, true)}
            onChange={this.setProValue}
            onLessonChange={this.setProLessons}
            toggleLesson={this.toggleLesson}
            addPriceGroup={this.addPriceGroup}
            removePriceGroup={this.removePriceGroup}
            addCustomLesson={this.addCustomLesson}
            onPackageChange={this.setProPackages}
            togglePackage={this.togglePackage}
            addCustomPackage={this.addCustomPackage}
            groupLessonOptions={groupLessonOptions}
            onWebsiteChange={this.onWebsiteChange}
            loading={this.state.loading} 
            saving={this.state.saving} 
            saved={this.state.saved}
            error={this.state.saveError}
            changeFormState={this.changeFormState}
          />
        </section>
      </article>
    )
  }
}

export default Profile



// WEBPACK FOOTER //
// ./src/pages/Profile.js